import { Component, EventEmitter, Input, Output } from '@angular/core';
import { radioActionStyles, radioContainerStyles, radioLabelStyles, RadioProps } from '@kite_aerolab/shared/components';
import { getRandomID } from '@kite_aerolab/shared/utils';
@Component({
  selector: 'kite-radio',
  template: `
    <div [ngClass]="radioContainer" (click)="handleFocus($event)" (keyup)="handleFocus($event)">
      <label [ngClass]="radioLabel">
        <input
          #inputRef
          type="radio"
          [id]="id"
          [required]="isRequired"
          [attr.value]="value"
          [disabled]="isDisabled"
          [checked]="isChecked"
          [attr.name]="name"
          [attr.aria-label]="ariaLabel || undefined"
          [attr.aria-labelledby]="ariaLabelledby"
          [attr.aria-invalid]="isInvalid"
          [attr.aria-checked]="isChecked"
          [attr.aria-describedby]="ariaDescribedby"
          [attr.aria-disabled]="isDisabled"
          (change)="onChange.emit($event)"
          (click)="onClick.emit($event)"
        />
        <span class="checkmark"></span>
        <span class="label">
          <span> {{ label }} </span>
          <span *ngIf="description"> {{ description }}</span>
        </span>
      </label>
      <div [ngClass]="radioAction">
        <span *ngIf="actionText" tabindex="0">{{ actionText }}</span>
        <ng-content select="action"></ng-content>
      </div>
    </div>
  `,
})
export class RadioComponent {
  focusable = false;
  /**
   * ID del radio.
   */
  @Input() id: string = getRandomID();
  /**
   * Required del radio.
   */
  @Input() required: boolean;
  /**
   * Checked del radio.
   */
  @Input() isChecked: boolean;
  /**
   * Value del radio.
   */
  @Input() value: boolean;
  /**
   * Name del radio.
   */
  @Input() name: string;
  /**
   * Aria Label del radio.
   */
  @Input('aria-label') ariaLabel: string;
  /**
   * Css
   */
  @Input() css: RadioProps['css'];
  /**
   * Estado deshabilitado del radio.
   */
  @Input() isDisabled: boolean;

  /**
   * Estado deshabilitado del radio.
   */
  @Input() description: string;
  /**
   * Label del radio button
   */
  @Input() label: string;
  /**
   * Label del radio button
   */
  @Input() isInvalid: boolean;
  /**
   *
   */
  @Input() isRequired: boolean;

  /**
   * Texto de la acción del radio button
   */
  @Input() actionText: string;

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  @Output() onChange: EventEmitter<any> = new EventEmitter();

  ariaLabelledby: string;

  ariaDescribedby: string;

  public get radioContainer(): string[] {
    return [radioContainerStyles({ isFocusable: this.focusable, css: this.css }).className];
  }

  public get radioLabel(): string[] {
    return [
      radioLabelStyles({
        isInvalid: this.isInvalid,
      }).className,
    ];
  }

  public get radioAction(): string[] {
    return [
      radioActionStyles({
        isDisabled: this.isDisabled,
      }).className,
    ];
  }

  handleFocus(event: any) {
    this.focusable = !!event.key;
  }

  ngAfterViewInit() {
    this.ariaLabelledby = this.id + '-label';
    this.ariaDescribedby = this.id + '-label';
  }
}
